import { OtpLoginViewModel } from '@apis/model';
import { toCaptchaViewModel, toOtpViewModel } from '@apis/responseTransformer';
import { OtpLoginResponse } from '@ul/api/lib/models/OtpLoginResponse';

export const toOtpLoginViewModel = (otpLoginResponse: OtpLoginResponse): OtpLoginViewModel => {
    const { success, responseCode } = otpLoginResponse;
    return {
        responseCode,
        success,
        captchaViewModel: toCaptchaViewModel(otpLoginResponse),
        otpViewModel: toOtpViewModel(otpLoginResponse),
    };
};
